import { Typography, Box } from '@mui/material'

export default function ExamRoom() {
   return (
      <Box>
         <Typography variant="h4">Ruang Ujian</Typography>
         <Typography>
            Belum ada ujian tersedia. Hubungi proktor untuk memulai ujian
         </Typography>
      </Box>
   )
}
